
import React, { createContext, useState,useEffect} from 'react';
import { Header } from './Header/Header';
import { MatchmakerProfileEdit } from '../Pages/MatchmakerProfileEdit';


export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(()=>{
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
   {children}
   
    </LanguageContext.Provider>
  );
};
